export const COLLECTION_TYPES = [
    { label: "Display Individual Lesson Images", value: "Individual_Lesson_Image" },
    { label: "Display Collection Image", value: "Collection_Image" },
    { label: "Display Theme", value: "Theme" },
  ];

export enum COLLECTION_FIELDS {
    COLLECTION_TYPE = 'collectionType',
    NAME = 'name',
    SUB_HEADING = 'subHeading',
    IS_SUB_HEADING = 'isSubHeading',
    BANNER_IMAGE = 'bannerImage',
    PACING = 'pacing',
    SUB_HEADING_HIGHLIGHT = 'subHeadingHighlight',
    COUNTRY = 'country',
    GRADE = 'grade'
}

export enum COLLECTION_ERROR_MSGS {
    COLLECTION_TYPE = 'Please choose a collection type.',
    NAME = 'Please add a name.',
    SUB_HEADING = 'Please input sub heading.',
    BANNER_IMAGE = 'Please select an image.'
}